import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Calendar, Star, Heart, Bookmark, Copy } from 'lucide-react';
import { trackEvent } from '../../../utils/analytics';

const S3_BASE = "https://romaya-storage.s3.ap-south-1.amazonaws.com/";

const getImageUrl = (key) => {
  if (!key) return 'https://images.unsplash.com/photo-1476514525535-07fb3b4ae5f1?w=800&q=80'; // Fallback
  return `${S3_BASE}${key.replace(/\.(jpg|png|jpeg)$/i, '-card.webp')}`;
};

const RecentTripCard = ({ trip }) => {
  // trip properties: slug, coverPhotoKey, title, destination, startDate, endDate, rating, likeCount, saveCount, copyCount
  
  const startDate = new Date(trip.startDate).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
  
  return (
    <Link
      to={`/community/${trip.slug}`}
      onClick={() => trackEvent('recent_trip_card_clicked', { trip_id: trip.id, slug: trip.slug, destination: trip.destination })}
      className="group block w-full rounded-2xl overflow-hidden bg-white shadow-sm hover:shadow-xl transition-all duration-300 transform hover:scale-[1.03]"
    >
      <div className="relative aspect-[4/3] overflow-hidden bg-gray-100">
        <img 
          src={getImageUrl(trip.coverPhotoKey)}
          alt={trip.destination}
          className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
          loading="lazy"
          onError={(e) => {
             // Fallback if webp variant doesn't exist
             if(e.target.src.includes('-card.webp')) {
                 e.target.src = `${S3_BASE}${trip.coverPhotoKey}`;
             }
          }}
        />
        
        {/* Gradient overlay */}
        <div className="absolute inset-0 bg-gradient-to-t from-gray-900/90 via-gray-900/20 to-transparent"></div>
        
        <div className="absolute bottom-4 left-4 right-4 flex justify-between items-end">
          <div className="text-white">
            <h3 className="font-black text-xl mb-1 line-clamp-1">{trip.title || trip.destination}</h3>
            <div className="flex items-center text-sm font-medium opacity-90 mb-1">
              <MapPin size={14} className="mr-1" /> {trip.destination}
            </div>
            <div className="flex items-center text-xs opacity-75">
              <Calendar size={12} className="mr-1" /> {startDate}
            </div>
          </div>
        </div>
      </div>
      
      {/* Footer stats */}
      <div className="p-4 bg-white border-t border-gray-50 flex items-center justify-between">
        <div className="flex items-center gap-1.5 px-2.5 py-1 bg-yellow-50 text-yellow-700 rounded-full text-xs font-bold">
          <Star size={12} className="fill-yellow-500" />
          <span>{trip.averageRating ? trip.averageRating.toFixed(1) : "New"}</span>
          {trip.reviewCount > 0 && <span className="text-yellow-800 ml-1 opacity-80">({trip.reviewCount})</span>}
        </div>
        
        <div className="flex items-center gap-4 text-gray-400 text-xs font-bold">
          <div className="flex items-center gap-1">
            <Heart size={14} /> {trip.likeCount || 0}
          </div>
          <div className="flex items-center gap-1">
            <Bookmark size={14} /> {trip.saveCount || 0}
          </div>
          <div className="flex items-center gap-1">
            <Copy size={14} /> {trip.copyCount || 0}
          </div>
        </div>
      </div>
    </Link>
  );
};

export default RecentTripCard;
